import { lazy } from 'react'

export const ShopCategoryList = lazy(() => import('./shop-category/ShopCategoryList'))
export const ShopSubCategoryList = lazy(() => import('./shop-sub-category/ShopSubCategoryList'))
export const ShopProductList = lazy(() => import('./shop-product/ShopProductList'))
